import BannerWrapper from "./TMHBannerWrapper"
import BannerNavBar from "./TMHBannerNavBar"

export default function TMHBanner({onlyGradient = false}) {
  return (
    <BannerWrapper className="wrapper-banner-v2" style={onlyGradient?{backgroundImage: "none"}:{}} >
      <BannerNavBar className="navbar-banner-v2">
      </BannerNavBar>
    </BannerWrapper>
  )
}